<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Congratulations!</h3>
            
            <p class="text-[14px] leading-[22px] mb-[1rem]">
                Your organization now has the foundational elements of a sustainable fundraising plan. The fundraising goals, budgets, and narrative that you have developed can be repurposed to create a compelling case for support, grant application narrative, and other material that you can use to promote your organization and fundraise.
            </p>
            
            <p class="text-[14px] leading-[22px] mb-[1rem]">
                The most important thing to remember is to stick to the goals within this Toolkit until you have raised the money that you need to undertake the projects and programs you have articulated.
            </p>
            
            <p class="text-[14px] leading-[22px] font-semibold">
                We look forward to hearing about your fundraising success!
            </p>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 